/**
 * 空态插图（ASSET-UI-010 第二版：I 10-09 出图、审图；原字节在 public/ui-assets/ASSET-UI-010/v2/，来源和指纹见同目录 SOURCE.md）。
 * 交了以后一直没接上（UI-EMPTY-ART-01 接到相册空、朋友圈空、私聊空、家庭群空四处）。
 * 纯装饰：显示 160×120，按显示尺寸用 320／480 两档（srcset），不放大；alt 空、读屏不念，空着的原因和下一步由旁边的字说。
 */
const BASE = "/ui-assets/ASSET-UI-010/v2";

export const EMPTY_ART = {
  /** 摊开的空相册，夹着一条带爪印小坠的书签 */
  album: `${BASE}/01-album-empty-v2`,
  /** 圆软木板，钉着一张空白便签 */
  circle: `${BASE}/02-friends-feed-empty`,
  /** 奶油色圆坐垫上的一部小手机，屏幕亮着、什么都没有 */
  chat: `${BASE}/03-chat-empty-v2`,
  /** 小木信箱，门开着，里面是空的 */
  family: `${BASE}/04-family-letters-empty`,
} as const;

export type EmptyArt = (typeof EMPTY_ART)[keyof typeof EMPTY_ART];

export function EmptyArtImage({ art, className = "ps-state__art" }: { art: EmptyArt; className?: string }) {
  return (
    <img
      className={className}
      src={`${art}@320x240.webp`}
      srcSet={`${art}@320x240.webp 320w, ${art}@480x360.webp 480w`}
      sizes="160px"
      width={160}
      height={120}
      alt=""
      aria-hidden="true"
      loading="lazy"
      data-art={art.slice(BASE.length + 1)}
    />
  );
}
